import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import EmployeeFormLayer from "../components/EmployeeFormLayer";

const EmployeeEditPage = () => {
    // In a real app, we would fetch user data here based on ID and pass it to AdminUserFormLayer
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* AdminUserFormLayer - reused for edit */}
                <EmployeeFormLayer />
            </MasterLayout>
        </>
    );
};

export default EmployeeEditPage;
